// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { PointerSensor, useSensor, useSensors } from '@dnd-kit/core';

// A drag starts only once the pointer has moved this far. A plain click on a folder or project
// card therefore never starts one, so the drag overlay never appears under a click and the card's
// own pointer-up handler still runs. Same threshold the cards use for their click-vs-drag test.
export const DRAG_ACTIVATION_DISTANCE = 5;

// One object for the life of the module: dnd-kit memoises each sensor on its options' identity,
// and a literal rebuilt per render would remake the sensors, and with them the context every
// draggable subscribes to, on every render of the page - re-rendering every memoised card.
const POINTER_SENSOR_OPTIONS = { activationConstraint: { distance: DRAG_ACTIVATION_DISTANCE } };

export const useDashboardDragSensors = () => useSensors(
  useSensor(PointerSensor, POINTER_SENSOR_OPTIONS),
);
